import { B3Tag } from '@/components';
import { useB3Lang } from '@b3/lang';

interface StatusProps {
  code: number;
}

interface StatusPropsTypeStatus {
  code: string;
}

interface InvoiceStatusProps {
  [key: string]: {
    [key: string]: string;
  };
}


export function DeliveryReleaseStatus(props: StatusProps) {
  const { code } = props;

  const b3Lang = useB3Lang();


  const getInvoiceStatus = (code: number) => {
    const invoiceStatus: InvoiceStatusProps = {
      1: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.notReleased'),
        color: '#F1C224',
      },
      2: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.partiallyReleased'),
        color: '#A7D4F3',
      },
      3: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.released'),
        color: '#516FAE',
      },
      4: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.releaseDiscarded'),
        color: '#C4DD6C',
      },
      5: {
        textColor: '#FFFFFF',
        name: b3Lang('invoice.releaseStatus.releaseCanceled'),
        color: '#D32F2F',
      },
      6: {
        textColor: '#FFFFFF',
        name: b3Lang('invoice.releaseStatus.notRelevant'),
        color: '#808080',
      },
      7: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.releaseCancellationRequested'),
        color: '#FFA500',
      },
      8: {
        textColor: '#000000',
        name: b3Lang('invoice.releaseStatus.releaseRequested'),
        color: '#00BFFF',
      },
    };  

    const statusInfo = invoiceStatus[code] || {};

    return statusInfo;
  };

  const status = getInvoiceStatus(code);

  return status.name ? (
    <B3Tag color={status.color} textColor={status.textColor}>
      {status.name}
    </B3Tag>
  ) : null;
}


export function DeliveryProcessingStatus(props: StatusProps) {
  const { code } = props;

  const b3Lang = useB3Lang();

  const getDeliveryProcessingStatus = (code: number) => {
    const deliveryProcessingStatus: InvoiceStatusProps = {
      1: {
        textColor: '#000000',
        name: b3Lang('deliveries.processingStatus.notStarted'),
        color: '#F1C224',
      },
      2: {
        textColor: '#000000',
        name: b3Lang('deliveries.processingStatus.inProcess'),
        color: '#A7D4F3',
      },
      3: {
        textColor: '#000000',
        name: b3Lang('deliveries.processingStatus.finished'),
        color: '#516FAE',
      },
      4: {
        textColor: '#000000',
        name: b3Lang('deliveries.processingStatus.notRelevant'),
        color: '#C4DD6C',
      },
      5: {
        textColor: '#FFFFFF',
        name: b3Lang('deliveries.processingStatus.interrupted'),
        color: '#D32F2F',
      },
    };

    return deliveryProcessingStatus[code] || {};
  };

  const status = getDeliveryProcessingStatus(code);

  return status.name ? (
    <B3Tag color={status.color} textColor={status.textColor}>
      {status.name}
    </B3Tag>
  ) : null;
}


export function DeliveryTypeStatus(props: StatusPropsTypeStatus) {
  const { code } = props;

  const b3Lang = useB3Lang();

  const getDeliveryTypeStatus = (code: string) => {
    const deliveryTypeStatus: InvoiceStatusProps = {
      OB: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.standard'),
        color: '#F1C224',
      },
      ODCF: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.consignmentFillUp'),
        color: '#A7D4F3',
      },
      ODCI: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.consignmentIssue'),
        color: '#516FAE',
      },
      ODSH: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.returnToSupplier'),
        color: '#C4DD6C',
      },
      ODSR: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.spareParts'),
        color: '#D32F2F',
      },
      ORTC: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.returnToCustomer'),
        color: '#808080',
      },
      OTCS: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.overTheCounterSales'),
        color: '#FFA500',
      },
      STOD: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.stockTransfer'),
        color: '#00BFFF',
      },
      TPDO: {
        textColor: '#000000',
        name: b3Lang('deliveries.type.thirdParty'),
        color: '#32CD32',
      },
    };

    return deliveryTypeStatus[code] || {};
  };

  const status = getDeliveryTypeStatus(code);

  return status.name ? (
    <B3Tag color={status.color} textColor={status.textColor}>
      {status.name}
    </B3Tag>
  ) : null;
}
